import { type HNItem } from "./hn";

const SAVED_KEY = "hn_saved_posts";

export function getSavedPosts(): HNItem[] {
  try {
    const data = localStorage.getItem(SAVED_KEY);
    return data ? JSON.parse(data) : [];
  } catch {
    return [];
  }
}

export function savePost(post: HNItem): void {
  const posts = getSavedPosts();
  if (!posts.find(p => p.id === post.id)) {
    posts.unshift(post); // Add to beginning
    localStorage.setItem(SAVED_KEY, JSON.stringify(posts));
  }
}

export function unsavePost(postId: number): void {
  const posts = getSavedPosts();
  const updated = posts.filter(p => p.id !== postId);
  localStorage.setItem(SAVED_KEY, JSON.stringify(updated));
}

export function clearSavedPosts(): void {
  localStorage.removeItem(SAVED_KEY);
}
